export default __webpack_public_path__ + "static/imgTyre-1a7c860d28ca49a939499a627c4cb472.webp";